import { SlideAIModalContent } from 'components/AITools/components/SlideAIModalContent';
import { SlideAIReportIssue } from 'components/AITools/components/SlideAIReportIssue';
import { useEffect, useState } from 'react';
import { ModalWithHeader } from 'components/Modals/ModalWithHeader';
import { useSelector } from 'react-redux';
import { aiToolsSelector } from 'store/slices/cmsSlice';
import { useGetCurrentAiModel } from 'components/pages/AppLibrary/AiModel/hooks';

export const SlideAIModelModal = ({
  selectedSlides,
  onClose,
  open,
  isProcessed = false,
  model,
  onRunStart,
  ...props
}) => {
  const [isReportOpen, setIsReportOpen] = useState(false);
  const aiToolsData = useSelector(aiToolsSelector);
  // mock for testing
  const [currentModel, setCurrentModel] = useState(
    aiToolsData.find((tool) => tool.toolId === open) || aiToolsData[0],
  );
  const { getCurrentModel } = useGetCurrentAiModel();

  useEffect(() => {
    if (currentModel || !open) {
      return;
    }

    getCurrentModel(open, setCurrentModel);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentModel]);

  const handleReportOpen = () => {
    setIsReportOpen(true);
  };

  const handleReportClose = () => {
    setIsReportOpen(false);
  };

  return currentModel ? (
    <ModalWithHeader
      header={currentModel?.title.toUpperCase()}
      isLimitedHeight
      showCloseIcon
      onClose={onClose}
      open={!!open}
      {...props}
    >
      {!isReportOpen ? (
        <SlideAIModalContent
          isProcessed={isProcessed}
          onClose={onClose}
          selectedSlides={selectedSlides}
          currentModel={currentModel}
          handleReportOpen={handleReportOpen}
          model={model}
          onRunStart={onRunStart}
        />
      ) : (
        <SlideAIReportIssue
          onClose={onClose}
          handleReportClose={handleReportClose}
        />
      )}
    </ModalWithHeader>
  ) : null;
};
